import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useState } from "react";

export const OcrImageModal = ({ isOpen, onClose, imgSrc }) => {
  const [scale, setScale] = useState(1);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const zoomIn = () => setScale((prev) => Math.min(prev + 0.2, 3));
  const zoomOut = () => setScale((prev) => Math.max(prev - 0.2, 0.4));
  const resetZoom = () => setScale(1);

  return (
    <div
      onClick={handleBackdropClick}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-[90%] max-w-3xl bg-white rounded-xl shadow-2xl overflow-hidden"
      >
        {/* Header */}
        <div className="flex justify-between items-center px-4 py-3 border-b bg-gray-50 sticky top-0 z-10">
          <h2 className="text-lg font-semibold text-gray-700">Uploaded Image</h2>
          <button onClick={onClose} className="text-gray-600 hover:text-black transition">
            <CloseIcon />
          </button>
        </div>

        {/* Zoom Controls with Tooltips */}
        <div className="flex justify-center gap-4 py-3 border-b bg-white sticky top-[52px] z-10">

          {/* Zoom Out */}
          <div className="relative group">
            <button
              onClick={zoomOut}
              className="px-3 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg"
            >
              <RemoveIcon />
            </button>
            <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 w-max px-2 py-1 text-xs bg-black text-white rounded opacity-0 group-hover:opacity-100 transition">
              Zoom Out
            </span>
          </div>

          {/* Reset Zoom */}
          <div className="relative group">
            <button
              onClick={resetZoom}
              className="px-3 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg"
            >
              <RestartAltIcon />
            </button>
            <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 w-max px-2 py-1 text-xs bg-black text-white rounded opacity-0 group-hover:opacity-100 transition">
              Reset Zoom
            </span>
          </div>

          {/* Zoom In */}
          <div className="relative group">
            <button
              onClick={zoomIn}
              className="px-3 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg"
            >
              <AddIcon />
            </button>
            <span className="absolute -bottom-8 left-1/2 -translate-x-1/2 w-max px-2 py-1 text-xs bg-black text-white rounded opacity-0 group-hover:opacity-100 transition">
              Zoom In
            </span>
          </div>
        </div>

        {/* Image container */}
        <div className="p-4 flex justify-center overflow-y-auto max-h-[75vh]">
          {imgSrc ? (
            <img
              src={imgSrc}
              alt="Captured Preview"
              className="rounded-lg shadow-md border object-contain transition-transform duration-200"
              style={{
                transform: `scale(${scale})`,
                transformOrigin: "center center",
              }}
            />
          ) : (
            <p className="text-gray-500 py-16">No image available</p>
          )}
        </div>
      </div>
    </div>
  );
};
